module.exports = __webpack_public_path__ + "img/Industriel.52c15f6.jpg";